/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { forkJoin, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { CorrespondenceDocumentsService, CorrespondenceItemService } from "@api";
import { getLastestIssuedItem, getNavigationUrl, validDBViewPermission } from "@shared/utils";
import { HttpErrorResponse } from "@angular/common/http";
import IViewPrepare from "../models/IViewPrepaer";
import LoadingService from "../services/loading.service";
import LocalContractUserService from "../services/local-contractUser.service";
import RouteParams from "../shared/route-params";
import BaseFunctionService from "@services/baseFunction.service";
import CorrespondenceStatus from "@models/CorrespondenceStatus";
import CorrespondenceRole from "@models/CorrespondenceRole";
import NavService from "@services/nav.service";

@Injectable({
  providedIn: "root"
})
export default class ViewResolver implements Resolve<IViewPrepare | undefined> {
  router = inject(Router);
  private loadingService = inject(LoadingService);
  private correspondenceItemService = inject(CorrespondenceItemService);
  private correspondenceDocumentsService = inject(CorrespondenceDocumentsService);
  localContractUserService = inject(LocalContractUserService);
  navService = inject(NavService);
  baseFunctionService = inject(BaseFunctionService);


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IViewPrepare | undefined> {
    this.loadingService.start();
    const itemId = route.params[RouteParams.ItemId];
    const contractId = route.parent.params[RouteParams.ContractId];
    const createNewURL = `/${contractId}/create/new`;
    if(state.url === createNewURL)
    {
      this.baseFunctionService.setContractId(contractId);
      return of(undefined);
    }

    return forkJoin([
      this.correspondenceItemService.getCorrespondenceItem(itemId),
      this.correspondenceDocumentsService.getAllCorrespondenceDocuments(itemId),
      this.correspondenceItemService.getCorrespondenceTopics(),
    ]).pipe(
      map(([item, documents, topicItems]) => {
        this.baseFunctionService.setEntity(item, documents);
        const filteredItems = validDBViewPermission(
          [item],
          this.localContractUserService,
          this.navService.getUser()
        );
        const lastIssued = getLastestIssuedItem(item);
        const IsConfidential = !lastIssued || lastIssued.IsConfidential;
        const user = this.navService.getUser();
        const role = this.localContractUserService.currentUserContractRole;
        const fromUser =
          item.correspondence_create
            ?.correspondence_reference_user_correspondence_create_FromTocorrespondence_reference_user;
        const toUser =
          item.correspondence_create
            ?.correspondence_reference_user_correspondence_create_ToTocorrespondence_reference_user;
        const hasRole =
          user.Email === fromUser?.Email ||
          user.Email === toUser?.Email ||
          (item.correspondence_cc_user &&
            item.correspondence_cc_user.filter((cc)=>{return !cc.DeletedBy}).map((cc) => cc.UserId).includes(user.Id));
        const noView = item.Status === CorrespondenceStatus.Void ? role !== CorrespondenceRole.DocControl : (item.ViewOnly === true && IsConfidential !== false && !hasRole);
        if(filteredItems.length === 0 || noView)
        {
          this.router.navigateByUrl(`/${item.ContractId}/list`);
        }
        const newURL = `/${getNavigationUrl(item)}`;
        if (state.url !== newURL) {
          this.router.navigateByUrl(newURL);
        }
        const topics = topicItems.map((t)=>t.Name);
        this.loadingService.stop();
        return { item, documents, topics };
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error);
        this.router.navigate([contractId, "error", error.status ? error.status : 500]);
        return of(null);
      }),
    );
  }
}
